import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import {
  fetchHomepageIfNeeded,
  fetchAttentionIndexIfNeeded,
  setSelectedSidebarNav,
  logout
} from '../../actions'
import SidebarComponent from '../../components/sidebar/SidebarComponent'
import AttentionComponent from '../../components/attention/AttentionComponent'
import Profile from '../../classes/profile'
import { LS_HOMEPAGE_KEY } from '../../constants/local_storage'
import GoogleAnalytics from '../../classes/GoogleAnalytics'
import { ATTENTION_INDEX_MODULE } from '../../constants/commons'

class AttentionContainer extends Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    profile: Profile.PropTypes,
    history: PropTypes.object,
    match: PropTypes.object,
    topicId: PropTypes.string,
    homepage: PropTypes.object,
    audienceAcquisition: PropTypes.object,
    logout: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    topAndTrending: PropTypes.object,
    attentionIndex: PropTypes.object,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string
    }),
    fetchHomepage: PropTypes.func.isRequired,
    fetchAttentionIndex: PropTypes.func.isRequired,
    setShortcutPreference: PropTypes.func,
    shortcutPreference: PropTypes.string,
    selectedNav: PropTypes.string,
    isContentIntelligence: PropTypes.bool,
    isCatalogAnalysis: PropTypes.bool,
    isPerformanceAnalysis: PropTypes.bool,
    isAIInsights: PropTypes.bool,
    selectedSidebarNav: PropTypes.func
  }

  componentDidMount () {
    GoogleAnalytics.trackGA(ATTENTION_INDEX_MODULE, this.props.location, this.props.profile)
    this.fetchData ()
  }

  fetchData = () => {
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    if (!homepage) {
      if (this.props.profile && this.props.profile.groups.length > 0) {
        const groups = this.props.profile.groups
        const groupName = groups.filter(group => group !== 'Admin')[0]
        this.props.fetchHomepage(groupName)
      }
    }
    this.props.fetchAttentionIndex()
  }

  render () {
    const { profile, location, shortcut, topAndTrending, attentionIndex, selectedNav, isContentIntelligence, isCatalogAnalysis, isPerformanceAnalysis, isAIInsights } = this.props
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    const myLogout = () => this.props.logout()
    return (
      <>
        <SidebarComponent
          isAdmin={this.props.isAdmin}
          profile={profile}
          logout={myLogout}
          location={location}
          homepage={homepage ? homepage : this.props.homepage}
          shortcut={shortcut}
          topicId={this.props.topicId}
          shortcutPreference={this.props.shortcutPreference}
          setShortcutPreference={this.props.setShortcutPreference}
          selectedSidebarNav={this.props.selectedSidebarNav}
          selectedNav={selectedNav}
          isContentIntelligence={isContentIntelligence}
          isCatalogAnalysis={isCatalogAnalysis}
          isPerformanceAnalysis={isPerformanceAnalysis}
          isAIInsights={isAIInsights}
      />
        <AttentionComponent
          isAdmin={this.props.isAdmin}
          topAndTrending={topAndTrending}
          attentionIndex={attentionIndex}
          shortcut={shortcut}
        />
      </>
    )
  }
}

function mapStateToProps () {
  return (state, ownProps) => {
    const profile = state.user.profile && new Profile(state.user.profile)
    const isAdmin = state.user.isAdmin
    const shortcut = ownProps.shortcut
    const homepage = state.homepage.list
    const selectedNav = state.sidebar.selectedNav
    const isContentIntelligence = state.sidebar.isContentIntelligence
    const isCatalogAnalysis = state.sidebar.isCatalogAnalysis
    const isPerformanceAnalysis = state.sidebar.isPerformanceAnalysis
    const topAndTrending = state.attentionIndex.topAndTrending
    const attentionIndex = state.attentionIndex.details
    const isAIInsights = state.sidebar.isAIInsights
    return {
      isAdmin,
      profile,
      shortcut,
      homepage,
      topAndTrending,
      attentionIndex,
      selectedNav,
      isContentIntelligence,
      isCatalogAnalysis,
      isPerformanceAnalysis,
      isAIInsights
    }
  }
}

function mapDispatchToProps (dispatch) {
  return {
    fetchHomepage: (groupName) => dispatch(fetchHomepageIfNeeded(groupName)),
    fetchAttentionIndex: () => dispatch(fetchAttentionIndexIfNeeded()),
    selectedSidebarNav: (nav) => dispatch(setSelectedSidebarNav(nav)),
    logout: () => dispatch(logout())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AttentionContainer)